// extracted by mini-css-extract-plugin
export default {"zoomModal":"Dba-z","image":"Eba-z","button":"Fba-z","isOverlayShown":"Gba-z"};